import apiClient from './client';

export interface RegisterSquadData {
  squadId: string;
  playerId?: string;
  notes?: string;
}

export interface TransferPlayerData {
  fromSquadId: string;
  toSquadId: string;
  notes?: string;
}

export const squadMemberApi = {
  registerForSquad: (data: RegisterSquadData) => {
    return apiClient.post('/squad-members/register', data);
  },

  approveMembership: (squadId: string, playerId: string) => {
    return apiClient.post(`/squad-members/${squadId}/${playerId}/approve`);
  },

  rejectMembership: (squadId: string, playerId: string, reason?: string) => {
    return apiClient.post(`/squad-members/${squadId}/${playerId}/reject`, { reason });
  },

  withdrawFromSquad: (squadId: string, playerId: string) => {
    return apiClient.post(`/squad-members/${squadId}/${playerId}/withdraw`);
  },

  getSquadMembers: (squadId: string, includeWithdrawn: boolean = false) => {
    return apiClient.get(`/squad-members/squad/${squadId}`, {
      params: { includeWithdrawn },
    });
  },

  getPlayerSquads: (playerId: string) => {
    return apiClient.get(`/squad-members/player/${playerId}`);
  },

  transferPlayer: (playerId: string, data: TransferPlayerData) => {
    return apiClient.post(`/squad-members/player/${playerId}/transfer`, data);
  },
};
